var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKetchSecondaryGlyphViolet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#9C64FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2844 39.8176V24.1045L37.8889 10.5H24.2844L9.625 25.1594L24.2844 39.8176Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.141 31.9609L18.5365 45.5666H32.141L46.8004 30.9072L32.141 16.2478V31.9609Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKetchSecondaryGlyphViolet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ketchSecondaryGlyphViolet.39006d1b2771b33fddf41e7883d5beee.svg";